import React, { FC, useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
//import { useFirebase } from "./Firebase";
import Papa from 'papaparse';

const DataContext =
  React.createContext<
    | {
      //config: any;
      homePage: any;
	  //location: any;
      baseSystem: any[] | null;
      decarbonSystem: any[] | null;
      stackedEnergy: any[] | null;
      hotColdData: any[] | null;
    }
    | undefined
  >(undefined);

export const DataProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  //const firebase = useFirebase();
  //const [config, setConfig] = React.useState<any>(undefined);
  //const [location, setLocation] = React.useState<string | null>(null);
  //const [showPopup, setShowPopup] = React.useState(false);
  const { pathname } = useLocation();
  const [homePage, setHomePage] = React.useState<any>(undefined);
  const [baseSystem, setBaseSystem] = React.useState<any[] | null>(null);
  const [decarbonSystem, setDecarbonSystem] = React.useState<any[]| null>(null);
  const [stackedEnergy, setStackedEnergy] = React.useState<any[]| null>(null);
  const [hotColdData, setHotColdData] = React.useState<any[]| null>(null);

  const baseSystemPath = `/natrium/interactive-display/newData/baseSystem.csv`;
  const decarbonPath = `/natrium/interactive-display/newData/decarbonizedSystem.csv`;
  const energyPath = `/natrium/interactive-display/newData/energyStacked.csv`;
  const hotColdPath = `/natrium/interactive-display/newData/hotCold.csv`;

  useEffect(()=>{

    fetch(baseSystemPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text();
    })
    .then((csvText) => {
      Papa.parse(csvText, {
        header: true, // Optional: if you want to treat the first row as header
        skipEmptyLines: true,
        dynamicTyping: true,
        complete: (result) => {
          //console.log(result);
          setBaseSystem(result.data);
        },
        error: (error: any) => {
          console.error('Error parsing CSV file:', error);
        },
      });
    })
    .catch((error: any) => {
      console.error('Error fetching CSV file:', error);
    });

    fetch(decarbonPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text();
    })
    .then((csvText) => {
      Papa.parse(csvText, {
        header: true, // Optional: if you want to treat the first row as header
        skipEmptyLines: true,
        dynamicTyping: true,
        complete: (result) => {
          //console.log(result);
          setDecarbonSystem(result.data);
        },
        error: (error: any) => {
          console.error('Error parsing CSV file:', error);
        },
      });
    })
    .catch((error: any) => {
      console.error('Error fetching CSV file:', error);
    });

    fetch(energyPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text();
    })
    .then((csvText) => {
      Papa.parse(csvText, {
        header: true, // Optional: if you want to treat the first row as header
        skipEmptyLines: true,
        dynamicTyping: true,
        complete: (result) => {
          //console.log(result);
          setStackedEnergy(result.data);
        },
        error: (error: any) => {
          console.error('Error parsing CSV file:', error);
        },
      });
    })
    .catch((error: any) => {
      console.error('Error fetching CSV file:', error);
    });

    fetch(hotColdPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text();
    })
    .then((csvText) => {
      Papa.parse(csvText, {
        header: true, // Optional: if you want to treat the first row as header
        skipEmptyLines: true,
        dynamicTyping: true,
        complete: (result) => {
          //console.log('Hot cold', result);
          setHotColdData(result.data);
        },
        error: (error: any) => {
          console.error('Error parsing CSV file:', error);
        },
      });
    })
    .catch((error: any) => {
      console.error('Error fetching CSV file:', error);
    });

  }, [])
  return (
    <DataContext.Provider
      value={{
        //config,
        homePage,
        baseSystem,
        decarbonSystem,
        stackedEnergy,
        hotColdData
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => React.useContext(DataContext);
